










































































import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import CreateNewProperty from '../../../../../../../../../../../components/BotProperties/components/Properties/CreateNewProperty.vue'
import Accordion from '../../../../../../../../../../Accordion/Accordion.vue'
import {
  GroupedBotProperty,
  PropertyGroup
} from '../../../../../../../../../../BotProperties/components/Properties/types'
import CreateNewLabel from '../../../../../../../../components/CreateNewLabel.vue'
import { ConditionsNodeProps } from '../../../../logic/types'
import { SelectedPropertyType } from '../types'
import UserPropertiesCellLabels from './components/UserPropertiesCellLabels.vue'
import UserPropertiesCellProperties from './components/UserPropertiesCellProperties.vue'

@Component({
  components: {
    CreateNewLabel,
    Accordion,
    UserPropertiesCellLabels,
    UserPropertiesCellProperties,
    CreateNewProperty
  },
  data() {
    return {
      SelectedPropertyType,
    }
  }
})
export default class UserPropertiesCell extends Vue {
  @Prop() properties!: Array<GroupedBotProperty>

  @Prop() labels!: ConditionsNodeProps['labels']

  @Prop() createLabel!:ConditionsNodeProps['createNewLabel']

  @Prop() createProperty!:ConditionsNodeProps['createNewProperty']

  @Prop() selectedId!: number

  labelsIsOpen = false

  systemIsOpen = false

  customIsOpen = false

  isPropertyModalOpen = false

  isLabelModalOpen = false

  @Watch('labelsIsOpen')
  labelsIsOpenWatcher(val: boolean): void {
    if (val) {
      this.systemIsOpen = false
      this.customIsOpen = false
    }
  }

  @Watch('systemIsOpen')
  systemIsOpenWatcher(val: boolean): void {
    if (val) {
      this.customIsOpen = false
      this.labelsIsOpen = false
    }
  }

  @Watch('customIsOpen')
  customIsOpenWatcher(val: boolean): void {
    if (val) {
      this.systemIsOpen = false
      this.labelsIsOpen = false
    }
  }

  @Emit()
  selectProperty(type: SelectedPropertyType, id: number): { type: SelectedPropertyType, id: number } {
    return { type, id }
  }

  handleSelectProperty(id: number) {
    this.selectProperty(SelectedPropertyType.Property, id)
  }

  created(): void {
    if (this.selectedId) {
      const label = this.labels()[this.selectedId]
      const property = this.properties.find((p) => p.id === this.selectedId)

      if (label) {
        this.labelsIsOpen = true
      }

      if (property) {
        if (property.group === PropertyGroup.Custom) {
          this.customIsOpen = true
        } else {
          this.systemIsOpen = true
        }
      }
    }
  }
}
